// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "psp-" + chunkId + "-" + {"385":"92f30bec9350d7122693","401":"a53952efa56353d58689"}[chunkId] + ".css";
};